export const INPUT_METHODS = {
  KEYBOARD: 'keyboard',
  MOUSE: 'Mouse click',
}
